import { render, staticRenderFns } from "./slproduct-add-or-update.vue?vue&type=template&id=4e33d7b2&scoped=true&"
import script from "./slproduct-add-or-update.vue?vue&type=script&lang=js&"
export * from "./slproduct-add-or-update.vue?vue&type=script&lang=js&"
import style0 from "./slproduct-add-or-update.vue?vue&type=style&index=0&id=4e33d7b2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e33d7b2",
  null
  
)

export default component.exports